import { Box } from "@mui/material";
import Flex from "../../../../../../../../components/Flex";
import Text from "../../../../../../../../components/Text";
import StyledFormModal from "../../../../../../../../components/globalModal/StyledModal";
import { DisclosureHost } from "../../../../../../../../hooks/use-disclosure";

interface ViewCancelReasonProps {
  disclosureHost: DisclosureHost;
}

const ViewCancelReason = ({ disclosureHost }: ViewCancelReasonProps) => {
  const ViewCancelReasonContent = ({ data }: { data: any }) => {
    return (
      <Flex flexDirection={"column"} gap={1} width="100%" height="100%" p={1}>
        <Text>{data}</Text>
      </Flex>
    );
  };

  return (
    <StyledFormModal
      open={disclosureHost.opened}
      onClose={() => disclosureHost.close()}
      dialogTitle="Cancellation Reason"
      sx={{
        "& .MuiDialog-paper": {
          width: "30vw",
          height: "30vh",
        },
      }}
    >
      <Box pt={2}>
        <ViewCancelReasonContent data={disclosureHost.data} />
      </Box>
    </StyledFormModal>
  );
};

export default ViewCancelReason;
